import React, { useState } from "react";
import { 
  Button, 
  // makeStyles 
} from "@material-ui/core";
import { useWallet } from "use-wallet";
import useModal from "../../hooks/useModal";
import WalletProviderModal from "../WalletProviderModal";
import AccountModal from "./AccountModal";
// import walletConnect from "../../assets/img/wallet-connect1.svg";

interface AccountButtonProps {
  text?: string;
}

// const useStyles = makeStyles({
//   changeColorBg: {
//     border: "none",
//     backgroundImage:
//       "linear-gradient(93deg, rgb(48, 9, 221) 0%, rgb(230, 29, 225) 40%, rgb(130, 29, 230) 70%, rgb(130, 29, 230) 102%)",
//     backgroundPosition: " -2px 0%",
//     backgroundSize: "220% 100%",
//     color: "white",
//     borderRadius: "10px",
//     padding: "10px 0px",
//     width: "100%",
//     textTransform: "none",
//     fontWeight: "normal",
//     fontSize: "16px",
//   },
// });

const AccountButton: React.FC<AccountButtonProps> = ({ text }) => {
  const { account } = useWallet();
  const [onPresentAccountModal] = useModal(<AccountModal />);

  const [isWalletProviderOpen, setWalletProviderOpen] = useState(false);

  const handleWalletProviderOpen = () => {
    setWalletProviderOpen(true);
  };

  const handleWalletProviderClose = () => {
    setWalletProviderOpen(false);
  };
  // const classes = useStyles();
  const buttonText = text ? text : "Unlock";

  return (
    <div style={{ width: "100%" }}>
    {!account ? (
      <Button
        onClick={handleWalletProviderOpen}
        className='buy-button'
        variant="contained"
        style={{width: "100%"}}
      >
        {/* <img src={walletConnect} alt="" /> &nbsp;&nbsp; */}
        {buttonText}
      </Button>
    ) : (
      <Button variant="contained" onClick={onPresentAccountModal} className='nav-wallet' color="primary">
        {`${account.substring(0, 5)}...${account.substring(account.length - 4)}`}
      </Button>
    )}

      <WalletProviderModal
        open={isWalletProviderOpen}
        handleClose={handleWalletProviderClose}
      />
      {/* <AccountModal open={isAccountModalOpen} handleClose={handleAccountModalClose}/> */}
    </div>
  );
};

export default AccountButton;
